module.exports = __webpack_public_path__ + "static/media/heart.2ce089cd.svg";